import api from './api';
import { SettingData, SettingResponse, SiteConfiguration, VersionInformation, InvoiceConfiguration } from '../types/setting';

// GET /api/site/settings
export const getSettings = async (): Promise<SettingResponse> => {
    const response = await api.get('settings');
    return response.data;
};

// PUT /api/site/settings/site-configuration
export const updateSiteConfiguration = async (
    data: Partial<SiteConfiguration>
): Promise<SettingResponse> => {
    const response = await api.put('settings/site-configuration', { siteConfiguration: data });
    return response.data;
};

// PUT /api/site/settings/version-information
export const updateVersionInformation = async (
    data: Partial<VersionInformation>
): Promise<SettingResponse> => {
    const response = await api.put('settings/version-information', { versionInformation: data });
    return response.data;
};

// PUT /api/v1/settings/invoice-configuration
export const updateInvoiceConfiguration = async (
    data: Partial<InvoiceConfiguration>
): Promise<SettingResponse> => {
    const response = await api.put('settings/invoice-configuration', data);
    return response.data;
};
